import styled, { css } from "styled-components";

interface StyledSelectBoxProps {
  $size: "large" | "medium" | "small";
  $width: string;
  $maxWidth: string;
  $maxHeight?: string;
  $readOnly: boolean;
  $disabled: boolean;
}

export const StyledSelectBox = styled.div<StyledSelectBoxProps>`
  display: flex;
  flex-flow: column nowrap;
  gap: 0.4rem;
  width: ${({ $width }) => $width};
  max-width: ${({ $maxWidth }) => $maxWidth};

  & > .label-area {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 0.4rem;
    width: max-content;
    font: ${({ $size }) =>
      $size === "large" ? "var(--label-medium-400)" : "var(--label-small-400)"};
    color: var(--text-gray-strong);
    & > .required {
      color: var(--sys-red-0);
    }
    & > .info {
      cursor: pointer;
      position: relative;
    }
  }

  & > .form-wrap {
    display: flex;
    flex-flow: row nowrap;
    gap: 0.4rem;
    width: 100%;
    & > .form-area {
      transition: all 0.1s ease;
      box-sizing: border-box;
      border-radius: 0.4rem;
      background-color: var(--bg-gray-normal);
      border: 0.1rem solid var(--bg-gray-2);
      display: flex;
      flex-flow: row nowrap;
      gap: 0.4rem;
      align-items: center;
      width: 100%;
      height: ${({ $size }) =>
        $size === "large" ? "4rem" : $size === "medium" ? "2.8rem" : "2rem"};
      padding: ${({ $size }) =>
        $size === "large" ? "0.7rem" : "0.3rem 0.7rem"};
      cursor: pointer;
      & > .chip-area {
        width: 100%;
        height: 100%;
        flex: 1;
        overflow: hidden auto;
      }
      & > .icon {
        ${({ $size }) =>
          $size === "large"
            ? css`
                width: 2rem;
                height: 2rem;
              `
            : $size === "medium"
            ? css`
                width: 1.6rem;
                height: 1.6rem;
              `
            : css`
                width: 1.2rem;
                height: 1.2rem;
              `};
        path {
          stroke: var(--text-gray-strong);
        }
      }
      & > .value {
        width: 100%;
        height: 100%;
        outline: none;
        border: none;
        padding: 0;
        background-color: transparent;
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font: ${({ $size }) =>
          $size === "large"
            ? "var(--body-medium-400)"
            : $size === "medium"
            ? "var(--body-small-400)"
            : "var(--label-small-400)"};
        color: var(--text-gray-strong);
        & > .placeholder {
          color: var(--text-gray-4);
        }
      }

      & > .dropdown-btn {
        transition: transform 0.1s ease;
        box-sizing: border-box;
        display: flex;
        width: fit-content;
        height: fit-content;
        background-color: transparent;
        border: none;
        padding: 0;
        cursor: pointer;
        & > .icon {
          transition: transform 0.2s ease;
          ${({ $size }) =>
            $size === "large"
              ? css`
                  width: 2rem;
                  height: 2.4rem;
                `
              : $size === "medium"
              ? css`
                  width: 1.6rem;
                  height: 2rem;
                `
              : css`
                  width: 1.2rem;
                  height: 1.2rem;
                `};
          path {
            stroke: var(--text-gray-strong);
            stroke-width: 1.4;
          }
        }
      }

      &:hover {
        background-color: var(--hovered);
        border: 0.1rem solid var(--bg-gray-2);
      }
      &.active {
        background-color: var(--bg-gray-normal);
        border: 0.1rem solid var(--bg-gray-strong);
        & > .dropdown-btn > .chevron-icon {
          transform: rotate(180deg);
        }
      }
      /* &:focus {
        outline: -webkit-focus-ring-color auto 1px;
      } */
    }
  }

  & > .info-area {
    display: flex;
    gap: 0.8rem;
    flex-flow: row nowrap;
    color: var(--text-gray-4);
    font: ${({ $size }) =>
      $size === "large" ? "var(--label-medium-400)" : "var(--label-small-400)"};
    & > .help {
      flex: 1;
    }
  }
  ${({ $readOnly }) =>
    $readOnly &&
    css`
      pointer-events: none;
      & > .form-area {
        border: 0.1rem solid var(--bg-gray-1);
        background-color: var(--bg-gray-0);
        color: var(--text-gray-strong);
        .placeholder {
          color: transparent;
        }
      }
    `}
  ${({ $disabled }) =>
    $disabled &&
    css`
      pointer-events: none;
      & > .label-area {
        color: var(--bg-gray-2);
      }
      & > .form-area {
        border: 0.1rem solid var(--bg-gray-1);
        background-color: var(--bg-gray-0);
        & > .value {
          color: var(--bg-gray-2);
          & > .placeholder {
            color: transparent;
          }
        }
        .icon path {
          stroke: var(--bg-gray-2) !important;
        }
      }
      & > .info-area {
        color: var(--bg-gray-2);
      }
    `}
`;
